const Toggle = () => {
  const items = Array.from(document.querySelectorAll(".toggle"));

  if (items.length > 0) {
    items.forEach((item) => {
      const opener = item.querySelector(".toggle__opener");

      opener.addEventListener("click", (e) => {
        e.preventDefault();

        items.forEach((item) => {
          item.classList.remove("active");
        });

        item.classList.add("active");
      });
    });
  }
};

export default Toggle;
